import http, { BASE_URL_API } from "./Http";

const fetchDateRange = async (selectedOption = "") => {
    return http.get(`/date-range/${selectedOption}`);
};

const fetchOrderStatusCount = async (dealerId = "", startDate = "", endDate = "") => {
    return http.get(
        `/reports/order-status-count?dealerId=${dealerId}&startDate=${startDate}&endDate=${endDate}`,
    );
};

const fetchSalesSummaryReport = async (
    dealerId = "",
    selectedOption = "",
    startDate = "",
    endDate = "",
) => {
    return http.get(
        `/reports/sales-summary?dealerId=${dealerId}&selectedOption=${selectedOption}&startDate=${startDate}&endDate=${endDate}`,
    );
};

const fetchDealerSalesSummary = async (
    dealerIds = [],
    startDate = "",
    endDate = "",
    page = 1,
    limit = 10,
) => {
    const dealerIdParam =
        Array.isArray(dealerIds) && dealerIds.length > 0 ? dealerIds.join(",") : dealerIds;

    return http.get(
        `/reports/dealer-sales-summary?dealerId=${dealerIdParam}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`,
    );
};

const exportDealerSalesSummaryCSV = async (dealerIds = [], startDate = "", endDate = "") => {
    const dealerIdParam =
        Array.isArray(dealerIds) && dealerIds.length > 0 ? dealerIds.join(",") : dealerIds;

    const queryParams = new URLSearchParams({
        dealerId: dealerIdParam,
        startDate,
        endDate,
    });

    const url = `${BASE_URL_API}/reports/download-dealer-sales-summary-csv?${queryParams.toString()}`;
    window.open(url, "_blank");
};

const fetchOrderMarginSummary = async (
    dealerIds = [],
    startDate = "",
    endDate = "",
    page = 1,
    limit = 10,
    sortBy = [],
) => {
    const dealerIdParam =
        Array.isArray(dealerIds) && dealerIds.length > 0 ? dealerIds.join(",") : dealerIds;

    const sortParam = sortBy.map(({ id, desc }) => `${id}.${desc ? "desc" : "asc"}`).join(",");

    return http.get(
        `/reports/order-margin-summary?dealerId=${dealerIdParam}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&sort=${encodeURIComponent(
            sortParam,
        )}`,
    );
};

const exportOrderMarginSummaryCSV = async (dealerIds = [], startDate = "", endDate = "") => {
    const dealerIdParam =
        Array.isArray(dealerIds) && dealerIds.length > 0 ? dealerIds.join(",") : dealerIds;

    const queryParams = new URLSearchParams({
        dealerId: dealerIdParam,
        startDate,
        endDate,
    });

    const url = `${BASE_URL_API}/reports/download-order-margin-summary-csv?${queryParams.toString()}`;
    window.open(url, "_blank");
};

const ReportService = {
    fetchDateRange,
    fetchOrderStatusCount,
    fetchSalesSummaryReport,
    fetchDealerSalesSummary,
    exportDealerSalesSummaryCSV,
    fetchOrderMarginSummary,
    exportOrderMarginSummaryCSV,
};

export default ReportService;
